import { usePermission } from '@/contexts/permission/usePermission';

interface PermissionWrapProps {
  perm: string;
  children: React.ReactNode;
}

export default function PermissionWrap({
  perm,
  children,
}: PermissionWrapProps) {
  const { hasPermission } = usePermission();
  if (!hasPermission(perm)) return null;
  return <>{children}</>;
}
